<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :width="canvasWidth" :height="canvasHeight" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="arrow-clip">
          <path ref="clipper" d="M1393.14,2414.54l-290.28-75.75c1.58-6,16.46-61.36,52.68-140.86a1272.6,1272.6,0,0,1,184.25-291.78c104.79-124.56,230.49-224.51,373.6-297.07,176.79-89.64,379.32-136.77,602-140.1l4.47,300c-176.64,2.63-335,38.87-470.78,107.7-106.93,54.22-201,129.12-279.71,222.63C1436.87,2256.75,1393.54,2413,1393.14,2414.54Z"/>
        </clipPath>
      </defs>
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
        <picture>
          <source :srcset="`${publicPath}scenes/map/Map-with_edits-480w.jpg`" media="(max-width: 480px)">
          <source :srcset="`${publicPath}scenes/map/Map-with_edits-768w.jpg`" media="(max-width: 768px)">
          <source :srcset="`${publicPath}scenes/map/Map-with_edits-1280w.jpg`" media="(max-width: 1280px)">
          <source :srcset="`${publicPath}scenes/map/Map-with_edits-1920w.jpg`" media="(max-width: 1920px)">
          <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/map/Map-with_edits.jpg`" />
        </picture>
      </foreignObject>
      <g clip-path="url(#arrow-clip)">
        <image width="1004" height="727" x="1248" y="1581" :xlink:href="`${publicPath}scenes/map/Map3.png`"/>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.33" :tx="1" :ty="0.5">
      Grandpa Jim sent Max to the Navajo Western Agency boarding school in
      Tuba City. Max made the most of it. He liked learning and took advantage
      of the resources there. He used to wake up early every Sunday morning
      for the trip from Shonto to Tuba City, just in time for dinner.
      <br><br>
      At school, Max learned the philosophy he kept his whole life: “To grow
      your own knowledge, you had to read.” And his home always had a lot of
      books.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/map/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 4175,
    canvasHeight: 3006,
    dy: 0,
  }),
  props: ["slide"],
  extends: Template,
  mounted() {
    // this.tl = new TimelineLite({paused: true, onComplete: this.audioPlay})
    TweenLite.set(this.$refs["clipper"], {rotate: "80deg", transformOrigin: "90% 120%"})
    TweenLite.set(this.$refs["scene"], {opacity: 0})
    TweenLite.set(this.$refs["dialogue"].$el, {opacity: 0})
    this.tl.add(TweenLite.to(this.$refs["scene"], 2, {opacity: 1}))
    this.tl.add(TweenLite.to(this.$refs["clipper"], 3, {rotate: "0deg", }))
    this.tl.add(TweenLite.to(this.$refs["dialogue"].$el, 1, {opacity: 1}), "-=1")
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  },
}
</script>
